import Vue from "vue";
import Router from "vue-router";
import store from "../store";

import Login from "../views/Login.vue";
import Home from "../views/Home.vue";
import Articulos from "../views/Articles/ArticlesList.vue";
import VentaForm from "@/views/Articles/VentaForm.vue";
import SaleList from "@/views/Articles/SaleList.vue";

import StatisticsView from "../views/Statistics/StatisticsView.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    { path: "/login", name: "login", component: Login },
    {
      path: "/",
      name: "home",
      component: Home,
      meta: { requiresAuth: true },
    },
    {
      path: "/articulos",
      name: "articulos",
      component: Articulos,
      meta: { requiresAuth: true },
    },
    {
      path: "/sales",
      name: "sales",
      component: SaleList,
      meta: { requiresAuth: true },
    },
    {
      path: "/venta",
      name: "venta",
      component: VentaForm,
      meta: { requiresAuth: true },
    },
    {
      path: "/statistics",
      name: "statistics",
      component: StatisticsView,
      meta: { requiresAuth: true },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((r) => r.meta.requiresAuth)) {
    if (!store.state.auth.token) {
      next("/login");
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
